import React, { useRef, useEffect } from "react";
import Parser from "html-react-parser";
import sanitizeHtml from "sanitize-html";
import ReactMarkdown from "react-markdown";
import "./summaryMessage.less";

interface Props {
    messageId: string;
    text: string;
    onTextContainerResized: () => void;
}

const SummaryMessage: React.FC<Props> = ({ messageId, text, onTextContainerResized }) => {
    const textRef = useRef<HTMLDivElement>();

    useEffect(() => {
        let resizeObserver = new ResizeObserver(() => {
            onTextContainerResized();
        });
        if (textRef.current) {
            resizeObserver.observe(textRef.current);
        }
        return () => resizeObserver.disconnect();
    }, [onTextContainerResized]);

    return (
        <div className="summary-message">
            <div className="summary-content" ref={textRef}>
                <h3 className="summary-heading">SUMMARY</h3>
                <ReactMarkdown>
                    {text}
                </ReactMarkdown>
            </div>
        </div>
    );
};

export default SummaryMessage;
